import React, {useState, useEffect } from "react";
import "./NewDevice.scss";
import DeviceServices from "../../services/api/DeviceServices";
import VesselServices from "../../services/api/VesselServices";
import { useMainContext } from "../../dataproviders/MainDataProvider";
import { useAuthContext } from "../../dataproviders/AuthDataProvider";
import { useDeviceContext } from "../../dataproviders/DeviceDataProvider";

function NewDevice() {
  const mainContext = useMainContext();
  const authContext = useAuthContext();
  const deviceContext = useDeviceContext();

  const [deviceData, setDeviceData] = useState({
    devicename: '',
    deviceurl: '',
    vesselid: '',
  });

  const [validationErrors, setValidationErrors] = useState({
    devicename: '',
    deviceurl: '',
    vesselid: '',
  });

  const handleVesselChange = (newVessel) => {
    setDeviceData((prevDeviceData) => ({
      ...prevDeviceData,
      vesselid: newVessel,
    }));

    setValidationErrors((prevValidationErrors) => ({
      ...prevValidationErrors,
        vesselid: '',
    }));
  };
  
  const [selectedOption, setSelectedOption] = useState('');
  const [selectedDescription, setSelectedDescription] = useState('');
  const [vesselDropdownState, setVesselDropdownState] = useState(false);
  const [vesselList, setVesselList] = useState([]);
  const [searchInputVessel, setSearchInputVessel] = useState('');
  const [filteredVessels, setFilteredVessels] = useState([]);
  const [pageTitle, setPageTitle] = useState('');
  const [currentVesselId, setCurentVesselId] = useState('');

const handleOptionClick = (option, name) => {
  handleVesselChange(option);
  setSelectedOption(option);
  setSelectedDescription(name);
  hideVesselDropdown();
};

const isOptionSelected = (option) => {
  return option === selectedOption ? 'selected' : '';
};

const renderSelectTag = (option) => {
  if (option === selectedOption) {
      return (
          <span className="select-tag float-right">
              <i className="fa-solid fa-check "></i>
          </span>
      );
  }
  return (
      <span className="select-tag">
      </span>
  );
};

  const handleInputChange = (event) => {
    const fieldName = event.target.dataset.field;
    const { name, value } = event.target;

    setDeviceData((prevDeviceData) => ({
      ...prevDeviceData,
      [name]: value,
    }));
    
    setValidationErrors((prevValidationErrors) => ({
      ...prevValidationErrors,
      [name]: value ? '' : `${fieldName} is required.`,
    }));
  };

  const handleSaveDevice = (e) => {
    const errors = {};
    if (!deviceData.devicename) {
      errors.devicename = 'Device name is required.';
    }

    if (!deviceData.deviceurl) {
      errors.deviceurl = 'Device URL is required.';
    }
    else
    {
      const urlRegex = /^(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)?)$/i;
      if(urlRegex.test(deviceData.deviceurl) === false)
      {
        errors.deviceurl = 'Invalid device URL format.';
      }
    }

    if (!deviceData.vesselid) {
      errors.vessel = 'Vessel is required.';
    }

    setValidationErrors(errors);

    
    if (Object.keys(errors).length === 0) {
        //Send data to server
        saveDevice(deviceData);
       
    }
  };

    const saveDevice = async (device) => {
        const cancelButton = document.getElementById("btnSaveDevice");

        try {
            // Disable the button and add the loading class
            cancelButton.disabled = true;
            cancelButton.innerHTML = '';
            cancelButton.classList.add('loading');

            //const result = await DeviceServices.AddDevice(newDevice.devicename, newDevice.deviceurl, newDevice.vesselid);
            let result = null;
            if(mainContext.DeviceState.deviceMode === "new"){
                result =  await DeviceServices.AddDevice(device);
            }
            else {
                result =  await DeviceServices.UpdateDevice(device,(currentVesselId !== device.vesselid));
            }

            if (!!result) {
                if (!result.data.errormessage) {
                    handleError('Success', 'Device has been successfully saved.');
                    deviceContext.SetRefreshFlag(true);
                }
                else {
                    handleError('Error', `Device has failed to save due to ${result.data.errormessage.toLowerCase()} Please try again.`);
                }
            }
            else {
                handleError('Error', 'Device has failed to save due to system error. Please try again.');
            }

            handleCancel();
        }
        catch (error) {
            // Display error message for network errors
            handleError('Error', 'An error occurred. Please try again later.');
        }
        finally {
            // Enable the button and remove the loading class
            cancelButton.disabled = false;
            cancelButton.innerHTML = 'Yes';
            cancelButton.classList.remove('loading');
        }
  };

    const handleCancel = () => {
        resetForm();

        mainContext.UpdateDeviceState({ showDeviceDetail: false, deviceMode: '', deviceData: {} });
    };

    const handleError = (errorType, errorMessage) => {
        authContext.HandleError(errorType, errorMessage);
    }

const resetForm = () => {
    setDeviceData({
      devicename: '',
      deviceurl: '',
      vesselid: '',
    });

    setValidationErrors({
      devicename: '',
      deviceurl: '',
      vesselid: '',
    });

    setSelectedOption('');
    setSelectedDescription('');
    hideVesselDropdown();

    //Reset dropdown search value
    handleResetSearchInputVessel();
}

  useEffect(() => {
    //Get dropdown vessel list
    getVessels();

    //Set dialog title New/Edit
    const title = mainContext.DeviceState.deviceMode.charAt(0).toUpperCase() + mainContext.DeviceState.deviceMode.slice(1);
    setPageTitle(title);
  
    //Bind data to dialog
    setDeviceData((prevDeviceData) => ({
      ...prevDeviceData,
      deviceid: mainContext.DeviceState.deviceData.deviceid,
      devicename: mainContext.DeviceState.deviceData.devicename,
      deviceurl: mainContext.DeviceState.deviceData.deviceurl,
      vesselid: mainContext.DeviceState.deviceData.vesselid,
    }));
    setCurentVesselId(mainContext.DeviceState.deviceData.vesselid);
    //Bind dropdown display text
    setSelectedDescription(mainContext.DeviceState.deviceData.vesselname);

}, [mainContext.DeviceState.showDeviceDetail]);

const toggleVesselDropdown = () => {
    setVesselDropdownState(!vesselDropdownState);
    //setPreviousVesselIndex(index);
    handleResetSearchInputVessel();
};

const hideVesselDropdown = () => {
  setVesselDropdownState(false);
};

const getVessels = async () => {
  const result = await VesselServices.GetVessels();
  if (!!result) {
    setVesselList(result.data);
  }
};

const handleSearchInputChangeVessel = (event) => {
  const searchValue = event.target.value;
  setSearchInputVessel(searchValue);

  const filteredVessels = vesselList.filter((vessel) =>
    vessel.vesselname.toLowerCase().includes(searchValue.toLowerCase())
  );
  setFilteredVessels(filteredVessels);
};

const handleResetSearchInputVessel = () => {
  setSearchInputVessel('');
  setFilteredVessels(vesselList);
};

  return( 
    <>
      <div className={`dialog-overlay ${mainContext.DeviceState.showDeviceDetail  ? '' : 'hidden'}`}>
      <div className="dialog-container dialog-container-long">
          <button className="dialog-close-button" onClick={handleCancel} >
                <i className="fa-solid fa-xmark"></i>
          </button>
          <p className="dialog-title col-rps-light mt-0 mb-0">{pageTitle} Device</p>
          <div className="dialog-content">
            <div className="mb-2">
              <div className="d-flex align-items-center input-label-group">
              <label htmlFor="txtDeviceName" className="w-30 required">Device Name</label>
              <input id="txtDeviceName" className={`${validationErrors.devicename ? 'error' :''} w-70`} type="text"  name="devicename"  data-field="Device Name"
              value={deviceData.devicename} 
              onChange={handleInputChange}
              onFocus={hideVesselDropdown}
              required
              />
             
              </div>
              {validationErrors.devicename && (
                  <label className="error error-message">
                        <i className="fa-solid fa-circle-info"></i> {validationErrors.devicename}
                    </label>
              )}
            </div>
            <div className="mb-2">
              <div className="d-flex align-items-center input-label-group">
              <label htmlFor="txtDeviceURL" className="w-30 required">Device URL</label>
              <input id="txtDeviceURL" className={`${validationErrors.deviceurl ? 'error' :''} w-70`} type="text"  name="deviceurl"  data-field="Device URL"
              value={deviceData.deviceurl} 
              onChange={handleInputChange}
              onFocus={hideVesselDropdown}
              required
              />
              </div>
              {validationErrors.deviceurl && (
                  <label className="error error-message">
                        <i className="fa-solid fa-circle-info"></i> {validationErrors.deviceurl}
                    </label>
              )}
            </div>
            <div className="mb-2">
              <div className="d-flex align-items-center input-label-group">
                     <label htmlFor="txtVessel" className="w-30 required">Vessel</label>
                    <div className="dropdown-container dropdown-container-vessel">
                      <button name="btnVessel" id="btnVessel" className={`btn-dropdown ${(validationErrors.vessel) ? 'dropdown-error' :''} ${vesselDropdownState ? 'btn-dropdown-expanded' : ''}`} 
                          onClick={() => toggleVesselDropdown()}
                          >
                          <span id="ddlSelectedOption" className="btn-dropdown-text float-left">
                             {selectedDescription}
                          </span>
                          <span className={`btn-dropdown-direction float-right ${vesselDropdownState ? 'col-rps' : ''}`}><i className={`fa-solid fa-chevron-down fa-set-middle`}></i></span>
                      </button>
                      <div className={`dropdown-content ${vesselDropdownState ? 'd-block' : 'd-none'}`} >
                    <div className="search-container">
                      <span className="search-icon">
                          <i className="fas fa-search"></i>
                      </span>
                      <input
                          type="text"
                          value={searchInputVessel}
                          onChange={handleSearchInputChangeVessel}
                          placeholder="Search..."
                          className="search-input"
                      />
                    </div>
                    <div className="dropdown-content-vessel-link dropdown-content-vessel">
                        {filteredVessels.map((ves, vesselindex) => (
                        <div key={`divFilterVessel_` + vesselindex} className={`dropdown-content-link ${isOptionSelected(ves.vesselid)}`} onClick={(e) => handleOptionClick(ves.vesselid, ves.vesselname)}>
                            <span>{ves.vesselname}</span>{renderSelectTag(ves.vesselid)}
                        </div>
                        ))}
                    </div>
                    </div>
                    </div>
            </div>
            {validationErrors.vessel && (
          <label className="error error-message">
          <i className="fa-solid fa-circle-info"></i> {validationErrors.vessel}
      </label>
          )}
            </div>
          </div>
          <div className="dialog-buttons float-right">
              <button id="btnSaveDevice" className="btn btn-dialog btn-primary btn-me"  onClick={handleSaveDevice}>Save</button>
              <button className="btn btn-dialog btn-secondary"  onClick={handleCancel}>Cancel</button>
          </div>
      </div>
      </div>
    </>
  );
}

export default NewDevice;
